import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseDeliveryOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/DeliveryOrder/DeliveryOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseDeliveryOrder"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseDeliveryOrder"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseDeliveryOrderActivity)
